/**
 * Shared between the root menu and a submenu, and between an item and a submenu trigger, so a nested
 * panel is indistinguishable from the one it opened out of.
 */
export const DROPDOWN_PANEL_CLASS = 'z-priority w-fit rounded-xl border border-subtle bg-surface-base shadow-dropdown outline-none'

export const DROPDOWN_PANEL_PADDING_CLASS = 'p-1.5'

// touch-manipulation: a row is tapped, never double-tapped, so opt it out of double-tap-to-zoom.
export const DROPDOWN_ITEM_CLASS =
    'flex h-8 touch-manipulation items-center gap-2 rounded-md px-2 py-1.5 text-default outline-none hover:cursor-pointer hover:bg-surface-muted focus:bg-surface-muted'

/** A row marked as in play without holding focus, such as the trigger of an open submenu. */
export const DROPDOWN_ITEM_ACTIVE_CLASS = 'bg-surface-muted'
